import React from 'react';

const CommunityCardSkeleton: React.FC = () => {
  return (
    <div className="bg-white rounded-xl shadow-md p-6 flex flex-col h-full border border-gray-100 relative overflow-hidden">
      {/* Shimmer overlay */}
      <div className="absolute inset-0 w-full h-full animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent z-10 pointer-events-none"></div>
      
      {/* Logo Section Skeleton */}
      <div className="flex items-start mb-5">
        <div className="w-16 h-16 border border-[#E9E9E9]/70 rounded-xl bg-gray-200/70 flex items-center justify-center animate-pulse"></div>
      </div>

      {/* Community Name Skeleton */}
      <div className="mb-3">
        <div className="h-6 bg-gray-200/70 rounded w-3/4 animate-pulse"></div>
      </div>

      {/* Description Skeleton */}
      <div className="mb-4 space-y-2 flex-grow">
        <div className="h-3 bg-gray-200/70 rounded w-full animate-pulse"></div>
        <div className="h-3 bg-gray-200/70 rounded w-5/6 animate-pulse"></div>
        <div className="h-3 bg-gray-200/70 rounded w-4/5 animate-pulse"></div>
      </div>

      {/* Address Skeleton */}
      <div className="flex items-start gap-2 mb-5">
        <div className="w-4 h-4 bg-gray-200/70 rounded flex-shrink-0 mt-0.5 animate-pulse"></div>
        <div className="flex-1 space-y-1">
          <div className="h-3 bg-gray-200/70 rounded w-full animate-pulse"></div>
          <div className="h-3 bg-gray-200/70 rounded w-2/3 animate-pulse"></div>
        </div>
      </div>

      {/* Resources Button Skeleton */}
      <div className="mt-auto pt-2">
        <div className="w-full h-12 bg-gray-200/70 rounded-lg animate-pulse"></div>
      </div>
    </div>
  );
};

export default CommunityCardSkeleton;

